/**
 * Stable RevenueCat appUserID for membership IAP on iOS.
 */

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/authStore';
import {
  isValidRevenueCatAppUserId,
  resolveRevenueCatAppUserId,
  resolveRevenueCatAppUserIdSync,
} from '@/utils/revenueCatAppUserId';

export function useRevenueCatAppUserId(): string | undefined {
  const user = useAuthStore((s) => s.user);
  const userId = user?.id;

  const [resolved, setResolved] = useState<string | undefined>(() => {
    const sync = resolveRevenueCatAppUserIdSync(user);
    return sync ?? undefined;
  });

  useEffect(() => {
    const sync = resolveRevenueCatAppUserIdSync(user);
    if (sync) {
      setResolved(sync);
      return;
    }

    if (!user || !useAuthStore.getState().isAuthenticated) {
      setResolved(undefined);
      return;
    }

    let cancelled = false;
    void resolveRevenueCatAppUserId().then((id) => {
      if (!cancelled) setResolved(id ?? undefined);
    });
    return () => {
      cancelled = true;
    };
  }, [user, userId]);

  if (isValidRevenueCatAppUserId(userId)) {
    return String(userId).trim();
  }

  return resolved;
}
